import { useEffect } from 'react';
import { useSnackbar } from 'notistack';

// Simple global toast service
export const toast = {
  // set by bridge
  enqueue: null as null | ((msg: string, options?: any) => void),
  success(message: string) {
    this.enqueue?.(message, { variant: 'success' });
  },
  error(message: string) {
    this.enqueue?.(message, { variant: 'error' });
  },
  info(message: string) {
    this.enqueue?.(message, { variant: 'info' });
  },
  warning(message: string) {
    this.enqueue?.(message, { variant: 'warning' });
  },
};

export default function ToastBridge() {
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    toast.enqueue = (msg: string, options?: any) => enqueueSnackbar(msg, options);
    return () => {
      toast.enqueue = null;
    };
  }, [enqueueSnackbar]);
  return null;
}
